import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { DollarSign, X } from 'lucide-react';
import { getAllPrices } from '../utils/currency';

export const CurrencyConverter = ({ basePrice, propertyTitle }) => {
  const [isOpen, setIsOpen] = useState(false);
  const prices = getAllPrices(basePrice);

  return (
    <div className="relative">
      <Button
        variant="outline"
        size="sm"
        onClick={() => setIsOpen(!isOpen)}
        className="border-[#FF8C42] text-[#FF8C42] hover:bg-[#FF8C42] hover:text-white"
      >
        <DollarSign className="w-4 h-4 mr-1" />
        View in Other Currencies
      </Button>

      {isOpen && (
        <div className="absolute top-full mt-2 right-0 z-50">
          <Card className="border-none shadow-2xl w-80">
            <CardContent className="p-4">
              <div className="flex justify-between items-center mb-3">
                <h4 className="font-bold text-[#404040]">Price Converter</h4>
                <button onClick={() => setIsOpen(false)} className="text-gray-400 hover:text-gray-600">
                  <X className="w-4 h-4" />
                </button>
              </div>
              
              <p className="text-xs text-gray-600 mb-3">{propertyTitle}</p>
              
              <div className="space-y-2">
                {Object.entries(prices).map(([currency, data]) => (
                  <div 
                    key={currency}
                    className="flex justify-between items-center p-2 rounded hover:bg-gray-50"
                  >
                    <div className="flex items-center space-x-2">
                      <span className="text-xl">{data.flag}</span>
                      <span className="text-sm font-medium text-gray-700">{currency}</span>
                    </div>
                    <span className="font-bold text-[#404040]">{data.formatted}</span>
                  </div>
                ))}
              </div>
              
              <p className="text-xs text-gray-500 mt-3 text-center">
                Exchange rates updated daily
              </p>
            </CardContent>
          </Card>
        </div>
      )}
    </div>
  );
};
